package uz.ferro.shop.document

import kotlinx.serialization.Serializable

@Serializable
data class FormattedText(
    val text: String?,
    val spans: List<TextSpan>? = null
)
